// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3sGDTzoKGVLAGa9wXseD5n {\n    flex: 1;\n    display: flex;\n    background-color: #eff1f3;\n}\n\n.OwTV7fWRxAgUod6T8Mp2k {\n    display: flex;\n    max-width: 1280px;\n}\n\n._2_dmP-OhYkcRtZGhaIFAoD {\n    margin-right: 32px;\n    flex: 5;\n}\n\n.l7Z_W0Jh1A7IT_Ors5TbI {\n    flex: 4;\n}\n\n._3kknyMY1khd0g6jXYo4yQR {\n    font-size: 14px;\n}\n\n._1f3uB4NvHv-kkk_6rcDraj {\n    align-items: center;\n    display: flex;\n    flex-direction: row-reverse;\n}\n\n._1f3uB4NvHv-kkk_6rcDraj a + a {\n    margin-right: 8px;\n}\n\n._2fKlapEt0chUA453C9Unai {\n    cursor: pointer;\n    font-weight: normal;\n}\n\n._2fKlapEt0chUA453C9Unai > input[type=\"checkbox\"] {\n    cursor: pointer;\n    font-size: 20px;\n    margin-right: 8px;\n}\n", ""]);
// Exports
exports.locals = {
	"page": "_3sGDTzoKGVLAGa9wXseD5n",
	"content": "OwTV7fWRxAgUod6T8Mp2k",
	"settings": "_2_dmP-OhYkcRtZGhaIFAoD",
	"preview": "l7Z_W0Jh1A7IT_Ors5TbI",
	"description": "_3kknyMY1khd0g6jXYo4yQR",
	"previewTypes": "_1f3uB4NvHv-kkk_6rcDraj",
	"label": "_2fKlapEt0chUA453C9Unai"
};
module.exports = exports;
